import { DevicesVisible, Layout } from '../../../types';

export const videoSettings = {
  scale: 100,
  ratio: 0.5625,
  autoplay: false,
  muted: true,
  areaWidth: 50,
  videoHeight: 300,
  layout: Layout.RightMedia,
  mobileLayout: Layout.EmbeddedMedia,
  mobileScale: 100,
  mobileRatio: 0.5625,
  horizontalSize: 40,
  horizontalSizeOnMobile: 40,
  horizontalBorderRadius: 0,
  verticalBorderRadius: 0,
  visible: true,
  devicesVisible: DevicesVisible.AllDevices
} as const;
